import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Công nợ › Theo debit / HĐ (Debit.tsx). Dữ liệu mẫu và mã nghiệp vụ không dịch.
addMessages('vi', {
  'db.aria': 'Công nợ theo debit và hoá đơn', 'db.noWrite': 'Chưa mở ghi ở bản này',
  'db.hNo': 'Số debit / HĐ · Job', 'db.hBill': 'Người được xuất (bill to)', 'db.hKind': 'Loại', 'db.hDate': 'Ngày · hạn',
  'db.hAmt': 'Số tiền', 'db.hLeft': 'Còn lại', 'db.hConf': 'Khách xác nhận', 'db.hRem': 'Nhắc nợ',
});
addMessages('en', {
  'db.aria': 'Receivables by debit note and invoice', 'db.noWrite': 'Writing is not enabled in this version',
  'db.hNo': 'Debit / invoice no. · Job', 'db.hBill': 'Billed party (bill to)', 'db.hKind': 'Type', 'db.hDate': 'Date · due',
  'db.hAmt': 'Amount', 'db.hLeft': 'Outstanding', 'db.hConf': 'Customer confirmation', 'db.hRem': 'Dunning',
});
